import { SYMBOL_HYPHEN } from '../../../constants/common'
import { useDateLocale, useTimeZone } from '../../../hooks'
import { formatDateRelativeToToday } from '../../../utils/date'
import Text from '../../Text'
import { ProfileUserInfoItem } from '../ProfileUserInfoItem'

import * as styles from './ProfileDateWithUserWidgetItem.module.css'

function ProfileDateWithUserWidgetItem({
  canViewUser = true,
  className = styles.ProfileDateWithUserWidgetItem,
  date,
  dateLabel,
  user,
  userLabel,
  userLabelClassName = styles.userLabel,
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const dateText = date
    ? formatDateRelativeToToday(date, locale, timezone)
    : SYMBOL_HYPHEN

  return (
    <div className={className}>
      <Text isSecondary className={styles.label}>
        {dateLabel}
      </Text>
      <Text className={styles.date}>{dateText}</Text>
      {canViewUser && user ? (
        <>
          <Text isSecondary className={userLabelClassName}>
            {userLabel}
          </Text>
          <ProfileUserInfoItem value={user} />
        </>
      ) : null}
    </div>
  )
}

export default ProfileDateWithUserWidgetItem
